<template lang="pug">
Auth(@loggedIn="loggedIn")
  NowLoading(:show="underLoading")
  div.sign-in
    ModuleSignIn
</template>

<style scoped lang="scss">
@import "@/scss/_variables.scss";

.sign-in {
  width: 100%;
  height: $device_height;
}
</style>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState, mapActions } = createNamespacedHelpers('auth')

import Auth from '@/components/shared/Auth'
import NowLoading from '@/components/shared/NowLoading'
import ModuleSignIn from '@/components/module/ModuleSignIn'

export default {
  components: {
    Auth,
    NowLoading,
    ModuleSignIn
  },
  computed: {
    ...mapState(['underLoading'])
  },
  data () {
    return {
      
    }
  },
  methods: {
    async loggedIn () {
      // const path = (this.$route.params.redirectPath) ? 
      //     decodeURIComponent(this.$route.params.redirectPath)
      //     : `/tmp1`
      // this.$router.replace(path).catch(error => {
      //   console.info(error.message)
      // })
    }
  }
}
</script>